import { Button, Stack, Typography } from '@mui/material';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import { colors } from 'theme/mui/colors';

import ShowSpin from 'components/v2/spin/ShowSpin';
import { useLocalization } from 'localization';
import { BranchDetails } from 'api/branches/dto';
import { useBranchCoverImage } from 'hooks/services/useBranchCoverImage';

type Props = {
  data?: BranchDetails;
  loading: boolean;
};

const BranchCoverImage = (props: Props) => {
  const { actions, apiStates } = useBranchCoverImage();
  const { data, loading } = props;

  const { t } = useLocalization();

  return (
    <Stack sx={{ width: '100%', borderRadius: 2, cursor: 'pointer' }}>
      <Stack
        sx={{
          width: '100%',
          position: 'relative',
          height: 200,
          borderRadius: '0.5rem',
          overflow: 'hidden',
          backgroundColor: colors.gray[300],
          transition: 'all 0.3s ease',
          justifyContent: 'center',
          alignItems: 'center',
          '&:hover': {
            backgroundColor: !data?.profile?.coverImageUrl ? colors.gray[300] : colors.gray[50],
          },
          '&:hover .overlay': { opacity: 1 },
          '&:hover .cover-img': { filter: 'blur(2px)' },
          '&:hover .center-upload': { opacity: 1 },
        }}
      >
        <ShowSpin when={apiStates.isLoading || loading}>
          <img
            src={data?.profile?.coverImageUrl ?? '/img/default-banner.jpg'}
            alt="coverImg"
            className="cover-img"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              transition: 'filter 0.3s ease',
            }}
          />
          <Stack
            className="overlay"
            direction="row"
            alignItems="center"
            justifyContent="center"
            sx={{
              position: 'absolute',
              inset: 0,
              opacity: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              transition: 'opacity 0.3s ease',
            }}
          >
            <Button
              component="label"
              variant="outlined"
              startIcon={<InsertPhotoIcon />}
              sx={{ color: 'white', borderColor: 'white' }}
            >
              <Typography variant="inherit">
                {data?.profile?.coverImageUrl ? t('accountSetting.replaceCover') : t('accountSetting.uploadCover')}
              </Typography>
              <input type="file" accept="image/*" onChange={actions.handleFileSelect} style={{ display: 'none' }} />
            </Button>
          </Stack>
        </ShowSpin>
      </Stack>
    </Stack>
  );
};

export default BranchCoverImage;
